import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class InvoiceSearchResultDto {
    vendorId: number;
    location: string;
    community: string;
    communityId: number;
    vendorName: string;
    vendorType: string;

    wfJobId: number;
    invoiceNumber: string;
    invoiceAmount: string;

    @Type(() => Date)
    invoiceDate: Date;

    approved: boolean;
    wfJobStatusHelpKey: string;
    wfJobStatus: string;
    paymentStatus: string;

    @Type(() => FileInfoDisplayResultDto)
    invoice: FileInfoDisplayResultDto;

    hasNotes: boolean;
}
